// Auto reload constants
export const AUTO_RELOAD_DEFAULTS = {
	THRESHOLD: 20,
	AMOUNT: 70,
} as const;

export const AUTO_RELOAD_LIMITS = {
	MIN: 20,
	MAX: 1e5,
	STEP: 50,
} as const;
